import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// Redux
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import { setWorkspaceType } from 'app/store/ui/uiSlice';
// Selectors
import { selectWorkspaceType } from 'app/store/ui/uiSelectors';
import { selectTotalPagesInWorkspace, selectEpisodesInWorkspace } from 'app/store/page/page.selectors';
// Mui
import { Box, Typography, Skeleton } from '@mui/material';

const WorkspaceInfoText = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  // ToDO
  // State
  const episodesInWorkspace:any = useAppSelector(selectEpisodesInWorkspace);
  const workspaceType = useAppSelector(selectWorkspaceType);
  const totalPages:any = useAppSelector(selectTotalPagesInWorkspace);

  useEffect(() => {
    return () => {
      dispatch(setWorkspaceType('pages'));
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ flexGrow: 1, display: 'flex' }}>
      {!totalPages ? (
        <Skeleton width={360} />
      ) : (
        workspaceType === 'pages' ? (
          <Typography sx={{ display: 'flex', gap: 2 }} variant="body2">
            {totalPages.totalMainPagesInWorkspace ? (
              <Box component="span">{t('pages.workspace.totalNumberOfPages')}: <b>{totalPages.totalMainPagesInWorkspace}</b></Box>
            ) : null}
            {totalPages.totalPagesInWorkspace ? (
              <Box component="span">{t('pages.workspace.includingStapledPages')}: <b>{totalPages.totalPagesInWorkspace}</b></Box>
            ) : null}
          </Typography>
        ) : (
          episodesInWorkspace ? (
            <Typography>{t('pages.workspace.totalEpisodes')}: <b>{episodesInWorkspace.length}</b>.</Typography>
          ) : null
        )
      )}
    </Box>
  )
}

export default WorkspaceInfoText;
